import {
    AUTHORIZE_MFP,
    AUTHORIZE_MFP_FAIL,
    AUTHORIZE_MFP_SUCCESS,
    FETCH_MFP,
    FETCH_MFP_FAIL,
    FETCH_MFP_INFO,
    FETCH_MFP_INFO_FAIL,
    FETCH_MFP_INFO_SUCCESS,
    FETCH_MFP_LAST_SYNC,
    FETCH_MFP_LAST_SYNC_FAIL,
    FETCH_MFP_LAST_SYNC_SUCCESS,
    FETCH_MFP_RECENT_CALORIES_GOAL,
    FETCH_MFP_RECENT_CALORIES_GOAL_DONE,
    FETCH_MFP_SUCCESS,
    SYNC_MFP_NOW,
    SYNC_MFP_NOW_FAIL,
    SYNC_MFP_NOW_SUCCESS
} from 'actions/ActionTypes';

const INITIAL_STATE = {
    entity: {},
    authorizationResponse: {},
    accountConflict: false,
    loadFailed: false,
    isLoading: false,
    newAccount: false,
    fetchingAccountInfo: false,
    accountInfo: {},
    fetchingLastSync: false,
    lastSync: null,
    syncingNow: false,
    syncNowResponse: {},
    recentCaloriesGoal: null
};

const fetchMfpSuccess = (state, action) => {
    return {
        ...state,
        entity: action.data,
        isLoading: false
    };
};

const fetchMfpFail = (state) => {
    return {
        ...state,
        loadFailed: true,
        entity: {},
        isLoading: false
    };
};

const mfpAuthorized = (state, action) => {
    return { ...state, authorizationResponse: action.data, newAccount: true };
};

const fetchMfp = (state) => {
    return { ...state, isLoading: true };
};

const mfpAuthorizationFailed = (state) => {
    return {
        ...state,
        accountConflict: true
    };
};

const fetchMfpAccountInfo = (state) => {
    return { ...state, fetchingAccountInfo: true };
};

const fetchMfpAccountInfoSuccess = (state, action) => {
    return { ...state, fetchingAccountInfo: false, accountInfo: action.data };
};

const fetchMfpAccountInfoFail = (state) => {
    return { ...state, fetchingAccountInfo: false, accountInfo: {} };
};

const fetchMfpLastSync = (state) => {
    return { ...state, fetchingLastSync: true };
};

const fetchMfpLastSyncSuccess = (state, action) => {
    return { ...state, fetchingLastSync: false, lastSync: action.data };
};

const fetchMfpLastSyncFail = (state) => {
    return { ...state, fetchingLastSync: false, lastSync: {} };
};

const syncingMfp = (state) => {
    return { ...state, syncingNow: true };
};

const mfpSyncSuccess = (state, action) => {
    return { ...state, syncingNow: false, syncNowResponse: action.data };
};

const mfpSyncedFail = (state) => {
    return { ...state, syncingNow: false, syncNowResponse: {} };
};

const fetchMfpRecentCaloriesGoalDone = (state, action) => {
    if (action.error) {
        return state;
    }
    return {
        ...state,
        recentCaloriesGoal: action.data
    };
};

const handlers = {
    [FETCH_MFP_SUCCESS]: fetchMfpSuccess,
    [FETCH_MFP_FAIL]: fetchMfpFail,
    [FETCH_MFP]: fetchMfp,
    [AUTHORIZE_MFP_SUCCESS]: mfpAuthorized,
    [AUTHORIZE_MFP_FAIL]: mfpAuthorizationFailed,
    [FETCH_MFP_INFO_SUCCESS]: fetchMfpSuccess,
    [FETCH_MFP_INFO_FAIL]: fetchMfpFail,
    [FETCH_MFP_INFO]: fetchMfpAccountInfo,
    [FETCH_MFP_INFO_SUCCESS]: fetchMfpAccountInfoSuccess,
    [FETCH_MFP_INFO_FAIL]: fetchMfpAccountInfoFail,
    [FETCH_MFP_LAST_SYNC]: fetchMfpLastSync,
    [FETCH_MFP_LAST_SYNC_SUCCESS]: fetchMfpLastSyncSuccess,
    [FETCH_MFP_LAST_SYNC_FAIL]: fetchMfpLastSyncFail,
    [SYNC_MFP_NOW]: syncingMfp,
    [SYNC_MFP_NOW_SUCCESS]: mfpSyncSuccess,
    [SYNC_MFP_NOW_FAIL]: mfpSyncedFail,
    [FETCH_MFP_RECENT_CALORIES_GOAL_DONE]: fetchMfpRecentCaloriesGoalDone
};

export default function mfp(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// Actions
export function fetchMFP() {
    return {
        type: FETCH_MFP
    };
}

export function authorizeMfp(authorizationCode, displayName) {
    return {
        type: AUTHORIZE_MFP,
        authorizationCode: authorizationCode,
        displayName: displayName
    };
}

export function fetchMFPAccountInfo() {
    return {
        type: FETCH_MFP_INFO
    };
}

export function fetchMfpLastSyncTime() {
    return {
        type: FETCH_MFP_LAST_SYNC
    };
}

export function syncMfpNow(calendarDate, displayName) {
    return {
        type: SYNC_MFP_NOW,
        calendarDate,
        displayName
    };
}

export function fetchMfpRecentCaloriesGoal() {
    return {
        type: FETCH_MFP_RECENT_CALORIES_GOAL
    };
}

//Selectors
export const getMfp = (state) => {
    return state.mfp.entity;
};

export const getMFPAccountConflict = (state) => {
    return state.mfp.accountConflict;
};

export const getMFPAuthorization = (state) => {
    return state.mfp.authorizationResponse;
};

export const isNewMfpAccount = (state) => {
    return state.mfp.newAccount;
};

export const getMfpAccountInfo = (state) => {
    return state.mfp.accountInfo;
};

export const isFetchingInfo = (state) => {
    return state.mfp.fetchingAccountInfo;
};

export const getMfpLastSyncTime = (state) => {
    return state.mfp.lastSync;
};

export const isMfpSyncingNow = (state) => {
    return state.mfp.syncingNow;
};

export const isMfpLoading = (state) => {
    return state.mfp.isLoading;
};

export const getMfpRecentCaloriesGoal = (state) => {
    return state.mfp.recentCaloriesGoal;
};
